import { render, staticRenderFns } from "./enterWX.vue?vue&type=template&id=3b1e3516&scoped=true"
import script from "./enterWX.vue?vue&type=script&lang=js"
export * from "./enterWX.vue?vue&type=script&lang=js"
import style0 from "./enterWX.vue?vue&type=style&index=0&id=3b1e3516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e3516",
  null
  
)

export default component.exports